import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltIconExternalLinkOutline } from '@cae/cobalt-react/icons/outline/CobaltIconExternalLinkOutline';
import { FeedbackContent } from '@shared/components/feedback-content/FeedbackContent';
import { ServiceUnavailableIllustration } from '@shared/components/feedback-content/illustrations/ServiceUnavailableIllustration';
import { COMMON_TICKET_URL } from '@shared/utils/support-urls/supportUrls';
import * as React from 'react';

import type { OrgCreateErrorBlockProps } from './OrgCreateErrorBlock.types';

const OrgCreateErrorBlock = React.memo(
  ({ org, retry }: Readonly<OrgCreateErrorBlockProps>): React.ReactElement => {
    return (
      <FeedbackContent
        title={`Oops! Something went wrong when creating the ${org.organizationName} organization in CAE Connect.`}
        message={
          <>
            Please try again. If the problem persists, please{' '}
            <CobaltLink href={COMMON_TICKET_URL} target="_blank" inline>
              open an IT ticket
              <CobaltIconExternalLinkOutline />
            </CobaltLink>{' '}
            .
          </>
        }
        illustration={<ServiceUnavailableIllustration />}
        primaryActionLabel="Try again"
        onPrimaryAction={retry}
      />
    );
  }
);

OrgCreateErrorBlock.displayName = 'OrgCreateErrorBlock';

export { OrgCreateErrorBlock };
